module.exports = __webpack_public_path__ + "static/media/document-text.c5cad47e.svg";